import { useEffect, useState } from 'react';

export default function AINews({ dark }) {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://alterus.onrender.com/api/ai-news')
      .then(r => r.json())
      .then(d => { setNews(d.news || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const openLink = (url) => window.open(url, '_blank');

  if (loading) return <div style={{ color: '#5a607a', fontSize: 12, fontFamily: 'DM Mono' }}>Loading news...</div>;
  if (news.length === 0) return <div style={{ color: '#5a607a', fontSize: 12 }}>No news available</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
      {news.slice(0, 5).map((item, i) => (
        <div
          key={i}
          onClick={() => openLink(item.url)}
          style={{
            padding: '8px 0',
            borderBottom: '1px solid #1e2235',
            cursor: 'pointer',
          }}
        >
          <div style={{ fontSize: 12, color: '#dde1f0', lineHeight: 1.4, marginBottom: 3 }}>{item.title}</div>
          <div style={{ fontSize: 10, color: '#6366f1', fontFamily: 'DM Mono' }}>{item.source} · {item.time}</div>
        </div>
      ))}
    </div>
  );
}
